import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PowerBIBookmark } from "../../_objects/analytics-powerbi-bookmark";

export function uniqueBookmarkNameValidator(getExistingBookmarks: () => PowerBIBookmark[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const existingBookmarks = getExistingBookmarks();
    if (!control.value) return null;

    const nameExists = existingBookmarks.some(
      (bookmark) => bookmark.bookmarkName.toLowerCase() === control.value.toLowerCase()
    );

    return nameExists ? { duplicateName: true } : null;
  };
}
